import { NgModule } from '@angular/core'
import { StageEffects } from '@data/store/stage/stage.effects'
import { stageMetaReducer, reducer as stageReducer } from '@data/store/stage/stage.reducer'
import { EffectsModule } from '@ngrx/effects'
import { ActionReducerMap, MetaReducer, StoreModule } from '@ngrx/store'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
import { StageState } from './stage/stage.state'

export interface AppState {
   stage: StageState
}

export const reducers: ActionReducerMap<AppState> = {
   stage: stageReducer,
}

export const metaReducers: MetaReducer<any>[] = [stageMetaReducer]

@NgModule({
   imports: [
      StoreModule.forRoot(reducers, {
         metaReducers,
         runtimeChecks: {
            strictStateImmutability: false,
            strictActionImmutability: true,
            strictStateSerializability: true,
            strictActionSerializability: false,
         },
      }),
      EffectsModule.forRoot([StageEffects]),
      StoreDevtoolsModule.instrument({
         maxAge: 25,
      }),
   ],
   exports: [StoreModule],
   providers: [],
})
export class StorageModule {}

